import { ITheme, ThemeService } from '@activia/ngx-components';
import { AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslocoService } from '@ngneat/transloco';
import { Subject, Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { AuthFacade } from '@amp/auth';
import { MessengerNotificationService } from '@amp/messenger';
import { WhiteLabelService } from '@amp/global';

@Component({ selector: 'cm-login', styleUrls: ['./login.style.scss'], templateUrl: './login.component.html', providers: [] })
export class LoginComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() previousUrl: string;

  @ViewChild('mainArea', { read: ElementRef, static: true }) main: ElementRef;

  pending$: Observable<boolean>;

  theme$: Observable<ITheme>;

  /** The login form */
  loginForm: FormGroup;

  /** @ignore Pattern used to close all subscriptions*/
  private componentDestroyed$: Subject<void> = new Subject();

  /** contains custom logo info if exist */
  customLogoInfo: { loginLogoPath?: string; appLogoPath?: string; background?: string };

  /**
   * @ignore
   */
  constructor(
    public translate: TranslocoService,
    private formBuilder: FormBuilder,
    private authFacade: AuthFacade,
    private messengerService: MessengerNotificationService,
    themeService: ThemeService,
    public whiteLabelService: WhiteLabelService,
    private renderer: Renderer2
  ) {
    this.pending$ = this.authFacade.pendingAuthentication$;
    this.theme$ = themeService.theme$;

    this.customLogoInfo = this.whiteLabelService.getCustomLogo();
  }

  /**
   * Called when the component is initiated
   *
   * @ignore
   */
  ngOnInit() {
    this.buildForm();
  }

  ngAfterViewInit() {
    this.whiteLabelService.customLoginLogoExists$.pipe(takeUntil(this.componentDestroyed$)).subscribe((exist) => {
      if (!exist) {
        this.messengerService.showErrorMessage('auth.error.custom-logo-not-found');
      } else {
        if (this.customLogoInfo && this.customLogoInfo.background) {
          this.renderer.setStyle(this.main.nativeElement, 'background', this.customLogoInfo.background);
        }
      }
    });
  }

  ngOnDestroy() {
    this.componentDestroyed$.next();
    this.componentDestroyed$.complete();
  }

  /**
   * Builds the login form
   */
  buildForm() {
    this.loginForm = this.formBuilder.group({ username: ['', Validators.required], password: ['', Validators.required] });
  }

  /**
   * Submit Login Button event
   */
  public submitLogin(event: MouseEvent): void {
    event.preventDefault();

    // if it's valid then init the login
    if (this.loginForm.valid) {
      this.login();
    }
  }

  login(): void {
    this.authFacade.login(this.loginForm.get('username').value, this.loginForm.get('password').value);
  }

  setLang(langId: string): void {
    this.translate.setActiveLang(langId);
  }
}
